import React, { useContext } from 'react';
import { Price, RegularButton, Typography } from 'fronton-react';
import { DataContext } from 'entries/common/widgets/context';
import { MEASUREMENT_TYPE } from 'pages/dimensions/const';
import { MeasurementBannerContainer, PriceBlock } from './styles';

export const MeasurementBanner = () => {
  const data = useContext(DataContext);
  const services = data?.surfaces?.services?.[0];
  const isShowMeasurementBanner = data?.surfaces.services?.length && services?.type === MEASUREMENT_TYPE;

  const priceMin = typeof services?.priceMin === 'number' ? services.priceMin : 0;

  const handleClickCallMaster = () => {
    window.open(services?.serviceURL, '_blank', 'noopener noreferrer');
  };

  return isShowMeasurementBanner ? (
    <MeasurementBannerContainer>
      <Typography variant="s" color="text-primary" size="body_long" data-testid="service-name-title">
        {services?.name}
      </Typography>
      <PriceBlock>
        <Typography size="body_accent" variant="l">
          от
        </Typography>
        <Price fraction size="l" value={priceMin} variant="medium" data-testid="min-price" />
      </PriceBlock>

      <RegularButton
        data-testid="call-master-button"
        invert
        variant="primary"
        onClick={handleClickCallMaster}>
        Вызвать мастера
      </RegularButton>
    </MeasurementBannerContainer>
  ) : null;
};
